<style>
  /* updated for Property Enquiry form - starts */
  #mauticform_genericproperyenquiryform_f_name {
    width: 48%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
  #mauticform_genericproperyenquiryform_last_name {
    width: 48%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
  #mauticform_genericproperyenquiryform_company {
    width: 98%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
  #mauticform_genericproperyenquiryform_email {
    width: 98%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
  #mauticform_genericproperyenquiryform_mobile {
    width: 98%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
  #mauticform_genericproperyenquiryform_property_enquiry {
    width: 98%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
  #mauticform_wrapper_genericproperyenquiryform .mauticform-label,
  #mauticform_wrapper_genericproperyenquiryform .mauticform-checkboxgrp-label {
    color: #637981;
  }
  .mauticform-text input {
    background-color: #fff;
  }
  #mauticform_wrapper_genericproperyenquiryform
    .mauticform-button-wrapper
    .mauticform-button,
  .mauticform-button-wrapper .mauticform-button.btn-default {
    background: #00353e;
    font-weight: 400;
    letter-spacing: -0.01em;
    text-transform: none;
  }
  #mauticform_wrapper_genericproperyenquiryform
    .mauticform-button-wrapper
    .mauticform-button {
    border: solid 2px #00353e;
    padding: 15px 38px 15px 30px;
    background-color: #00353e;
    color: white;
    font-family: "Overpass", sans-serif;
    border: solid 2px #00353e;
    background-image: url("icon-arrow-button.svg");
    background-repeat: no-repeat;
    background-position: 96% center;
  }
  #mauticform_wrapper_genericproperyenquiryform
    .mauticform-button-wrapper
    .mauticform-button:hover {
    color: #ffffff !important;
    background-color: #00353e !important;
  }
  /* updated for Property Enquiry form - ends */
</style>

<div class="bg">
  <app-breadcrumbs
    grandparentTitle="Home"
    grandparentLink="/"
    parentTitle="Our properties"
    parentLink="/properties/property-portfolio"
    anotherLink="/vacancies"
    anotherTitle="Our Vacancies"
    [childTitle]="currentProp.buildingName"
  ></app-breadcrumbs>
  <app-property-title-block
    *ngIf="doneLoading"
    [title]="currentProp.buildingName"
    link=""
    linkText="Contact"
    [image]="getImage(currentProp.imageBucketUrl, currentProp.frontPageImage)"
    [text]="currentProp.description"
    [subTitle]="currentProp.province"
    [contacts]="currentProp.buildingContactableList"
  ></app-property-title-block>

  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>

  <div class="container">
    <div class="col">
      <app-form-enquiry
        *ngIf="doneLoading"
        [id]="id"
        [title]="currentProp.buildingName"
        [contacts]="currentProp.buildingContactableList"
      ></app-form-enquiry>
    </div>
    <div class="col">
      <app-property-gallery-block
        *ngIf="doneLoading"
        statText1="GLA"
        [stat1]="currentProp.buildingGla"
        statText2="Total Units"
        [stat2]="currentProp.totalUnits"
        statText3="Sector"
        [stat3]="currentProp.sector"
        [img1]="
          getImageSrc(currentProp.imageBucketUrl, currentProp.frontPageImage)
        "
        [img2]="
          getImageSrc(currentProp.imageBucketUrl, currentProp.frontPageImage)
        "
        [img3]="
          getImageSrc(currentProp.imageBucketUrl, currentProp.frontPageImage)
        "
        [img4]="
          getImageSrc(currentProp.imageBucketUrl, currentProp.frontPageImage)
        "
        [img5]="
          getImageSrc(currentProp.imageBucketUrl, currentProp.frontPageImage)
        "
        [images]="currentProp.buildingImages"
        [bucket]="currentProp.imageBucketUrl"
      ></app-property-gallery-block>
    </div>
  </div>

  <div class="containerUnits" *ngIf="showUnits">
    <h3>Available Units Breakdown</h3>
    <table class="table">
      <thead>
        <tr>
          <th>Unit Name</th>
          <th>Category</th>
          <th>GLA</th>
          <th>Available lease date</th>
          <th>Brochure</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let unit of units; let i = index">
          <td>{{ unit.unitName }}</td>
          <td>{{ unit.unitCategoryString }}</td>
          <td>{{ unit.unitGla }}</td>
          <td *ngIf="getDate(unit.availableDate) < now">Available</td>
          <td *ngIf="getDate(unit.availableDate) > now">
            {{ unit.availableDate | date : "d MMMM YYYY" }}
          </td>
          <td (click)="download(unit.id)">
            <img
              style="width: 20px"
              src="../../../../assets/icons/icon-download.webp"
              alt=""
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-video
    *ngIf="
      doneLoading &&
      currentProp.videoUrl !== '' &&
      currentProp.videoUrl !== null
    "
    title="Explore this property virtually"
    text=""
    subtitle="discover the property"
    [embed]="currentProp.videoUrl"
    sideVideo="right"
  ></app-video>

  <!-- <app-video-vr
    *ngIf="doneLoading && currentProp.virtualTourUrl !=='' && currentProp.virtualTourUrl !== null"
    title="VR Footage"
    text="Explore what it is that makes us different, or take a look through our property portfolio."
    subtitle="discover the property"
    [embed]='currentProp.virtualTourUrl'
    sideVideo="right"    
    ></app-video-vr>-->

  <app-property-address-block
    *ngIf="doneLoading"
    [address]="currentProp.streetAddress"
    [province]="currentProp.province"
    [features]="currentProp.buildingFeatures"
    [lat]="currentProp.latitude"
    [long]="currentProp.longitude"
    [web]="currentProp.webUrl"
    [google]="currentProp.virtualTourUrl"
  ></app-property-address-block>

  <!--<div class="containerUnits">
        <h3>Get in touch</h3>
        <div class="message" *ngIf="messageSent">
            <p  *ngIf="message" class="success">Your message was sent successfully, an asset manager will be in touch with you.</p>
            <p *ngIf="!message" class="error">There was an error sending your message, please try again later.</p>
        </div>
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" *ngIf="!messageSent">
            <input  placeholder="Name and Surname" type="text" formControlName="firstName">
            <input type="text" placeholder="Email" formControlName="contactEmail">
            <input type="text" placeholder="Phone number" formControlName="contactPhone">
            <textarea  type="text" formControlName="notes" placeholder="Notes"></textarea>
            <button class="primary-btn-arrow" type="submit" [disabled]="!profileForm.valid">Send query</button>
        </form>
    </div>-->

  <app-get-in-touch-banner></app-get-in-touch-banner>

  <app-similar-properties
    [props]="allProp"
    [sector]="currentProp.sector"
    [currentID]="currentProp.id"
    *ngIf="doneLoading"
  ></app-similar-properties>

  <app-subscribe-banner></app-subscribe-banner>
</div>
